'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'bags-shopping';
var width = 576;
var height = 512;
var aliases = [128717];
var unicode = 'f847';
var svgPathData = ['M16 176l416 0 0 48-272 0 0 240L16 464l0-288zm192 96l352 0 0 224-352 0 0-224zm96 48l0 8 0 40c0 44.2 35.8 80 80 80l8 0 0-.4c40.4-4 72-38.1 72-79.6l0-40 0-8-16 0 0 8 0 40c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-40 0-8-16 0z', 'M144 96c0-44.2 35.8-80 80-80s80 35.8 80 80l0 64-160 0 0-64zm-16 64L16 160 0 160l0 16L0 464l0 16 16 0 144 0 0-16L16 464l0-288 416 0 0 48 16 0 0-48 0-16-16 0-112 0 0-64c0-53-43-96-96-96s-96 43-96 96l0 64zm80 112l352 0 0 224-352 0 0-224zm-16-16l0 16 0 224 0 16 16 0 352 0 16 0 0-16 0-224 0-16-16 0-352 0-16 0zm128 72l0-8-16 0 0 8 0 40c0 44.2 35.8 80 80 80l8 0 0-.4c40.4-4 72-38.1 72-79.6l0-40 0-8-16 0 0 8 0 40c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-40z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBagsShopping = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;